// istanbul ignore file todo CD-50871
import { Button, IStyleConfig, mergeStyles } from '@cian/components';
import * as React from 'react';

const style = require('./index.css');

export interface IButtonPhoneProps {
  phone: string;
  phoneAsLabel?: boolean;
  containerStyle?: IStyleConfig;
  buttonStyle?: IStyleConfig;
  textStyle?: IStyleConfig;
  phoneStyle?: IStyleConfig;
  newbuildingId?: number | null;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void | Promise<void>;
}

interface IButtonPhoneState {
  clicked: boolean;
}

// tslint:disable-next-line:no-default-export
export default class ButtonPhone extends React.Component<IButtonPhoneProps, IButtonPhoneState> {
  public state = {
    clicked: false,
  };

  public constructor(props: IButtonPhoneProps) {
    super(props);
  }

  public render() {
    if (this.props.phoneAsLabel) {
      return this.renderPhone();
    }

    return this.renderDefault();
  }

  public renderDefault() {
    let viewer: React.ReactNode;

    if (!this.state.clicked) {
      viewer = (
        <Button
          theme="button/solid"
          // tslint:disable-next-line:no-any
          buttonStyle={mergeStyles(style['button'], this.props.buttonStyle) as any}
          onClick={this.onClick}
        >
          <span {...mergeStyles(style['buttonText'], this.props.textStyle)}>Показать телефон</span>
        </Button>
      );
    } else {
      viewer = (
        <span {...mergeStyles(style['phone'], this.props.phoneStyle)}>{this.parsePhoneNumber(this.props.phone)}</span>
      );
    }

    return <div {...mergeStyles(style['container'], this.props.containerStyle)}>{viewer}</div>;
  }

  public renderPhone() {
    let viewer: React.ReactNode;

    if (!this.state.clicked) {
      viewer = (
        <Button
          theme="button/solid"
          // tslint:disable-next-line: no-any
          buttonStyle={mergeStyles(style['button'], this.props.buttonStyle) as any}
          onClick={this.onClick}
        >
          <span {...mergeStyles(style['buttonText'], style['buttonText--phone'], this.props.textStyle)}>
            {this.hideLastDigits(this.parsePhoneNumber(this.props.phone))}
          </span>
          <span {...mergeStyles(style['buttonText'], style['buttonText--hideable'], this.props.textStyle)}>
            Показать телефон
          </span>
        </Button>
      );
    } else {
      viewer = (
        <span {...mergeStyles(style['phone'], this.props.phoneStyle)}>{this.parsePhoneNumber(this.props.phone)}</span>
      );
    }

    return <div {...mergeStyles(style['container'], this.props.containerStyle)}>{viewer}</div>;
  }

  private hideLastDigits = (phoneNumber: string) => {
    return phoneNumber.slice(0, -3).concat('\u2026');
  };

  private parsePhoneNumber = (phoneRaw: string): string => {
    const phone = phoneRaw.replace(/\D/g, '');

    // tslint:disable-next-line:max-line-length
    return `+${phone.substr(0, 1)} ${phone.substr(1, 3)} ${phone.substr(4, 3)}-${phone.substr(7, 2)}-${phone.substr(
      9,
      2,
    )}`;
  };

  private onClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (this.props.onClick) {
      await this.props.onClick(event);
    }

    this.setState({
      clicked: true,
    });
  };
}
